// Mobile Menu Toggle
const mobileMenuToggle = (function () {
    function privateInitListeners() {
        const toggle = document.querySelector('.js-mobile-menu-toggle');

        document.addEventListener('click', (e) => {
            if (!e.target.matches('.js-mobile-menu-toggle')) return;

            e.stopPropagation();
            if (e.preventDefault) {
                e.preventDefault();
            }

            toggle.classList.toggle('active');
            const mobileNav = document.querySelector('.js-nav-menu');
            mobileNav.classList.toggle('active');
            document.body.classList.toggle("stop-scrolling");
        });
    }

    return {
        initListeners () {
            privateInitListeners();
        },
    };
})();

// Accordion Toggle
const accordionToggle = (function () {
    function privateInitListeners() {
        $('.js-nav-label').click(function (e) {
            if ($(window).width() <= 768) {
                e.stopPropagation();
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                }
            }

            const $this = $(this);
            const $item = $this.parent('.nav-item');
            const $menu = $item.closest('.js-nav-menu');

            if (!$item.hasClass('active')) {
                $('.nav-item.active', $menu).removeClass('active');
                $item.addClass('active');
            } else {
                $item.removeClass('active');
            }
        });
    }

    return {
        initListeners () {
            privateInitListeners();
        },
    };
})();

// Document Ready
jQuery(document).ready(() => {
    mobileMenuToggle.initListeners();
    accordionToggle.initListeners();
});
